import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from "axios";

import styles from "./Auth.module.css"
import guestii_gif from '../../assets/images/guestii_gif.gif'


const Authenticating = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const initiate = async () => {
            const params = new URLSearchParams(location.search);
            const googleCode = params.get('code');

            try {
                const response = await axios.get(`/api/auth/google-callback?code=${googleCode}`)

                if (response.data.valid) {
                    localStorage.setItem('_id', response.data.userID);
                    localStorage.setItem('expiry', response.data.token);

                    navigate(`/hub/${response.data.userID}`);
                } else {
                    localStorage.removeItem('expiry');
                    localStorage.removeItem('_id')
                    
                    navigate('/connect');
                }
            } catch (e) {
                localStorage.removeItem('expiry');
                localStorage.removeItem('_id')
                
                navigate('/connect');
            }
        }

        initiate()
    }, [location, navigate]);


    return (
        <div className={styles.background}>
            <img src={guestii_gif} className={styles.logo_gif}/>
        </div>
    );
};

export default Authenticating;